import React from 'react';
import { Box, Button, Typography, Select, MenuItem } from '@mui/material';
import { DataGridPro, GridToolbarQuickFilter } from '@mui/x-data-grid-pro';
import { GridToolbarContainer } from '@mui/x-data-grid-pro';
import * as BundleApi from '../../Bundles/BundleApi';
import { CountryCodeMap } from 'Services/CountryService';
import { BundleTypeList } from '../../Bundles/BundleService';

export default function BundleSelector({ onCardObjectSelected }) {
    return (
            <BundleList onCardObjectSelected={onCardObjectSelected} />
    );
}

function BundleList({ onCardObjectSelected }) {

    const [gridList, setGridList] = React.useState([]);
    const [bundleList, setBundleList] = React.useState([]);

    const loadBundles = React.useCallback(async () => {        
        const data = await BundleApi.getBundleList() || [];
        setBundleList(data);
    }, [setBundleList]);

    React.useEffect(() => {
        setGridList(bundleList);
    }, [bundleList])

    React.useEffect(() => {
        (async () => {
            loadBundles()
        })();
    }, [loadBundles]);

    function selectRow(row) {       
        onCardObjectSelected(row);
    }

    function updateFilters(filters) {
        if (filters.tags && filters.tags.length) {
            const results = bundleList.filter((mx) => mx.bundleType?.toLowerCase() === filters.tags?.toLowerCase() );
            setGridList(results);
        }  else {
            setGridList(bundleList);
        }
    }

    const columns = [        
        {
            field: 'id',
            headerName: 'Bundle Id',
            width: 200,
            editable: false,
        },
        {
            field: 'statusCode',
            headerName: 'Status',
            width: 150,
            editable : false,
        }, 
        {
            field: 'bundleName',
            headerName: 'Bundle Title',
            width: 200,
            editable: false,
        },
        {
            field: 'bundleType',
            headerName: 'Category',
            width: 130,
            editable: false,
        },
        {
            field: 'connections',
            headerName: 'Connection',
            width: 200,
            editable: false,
            valueGetter: (params) => {
                return params.row.heroProduct?.name || '-';
            },
        },
        {
            field: 'countryList',
            headerName: 'Location',
            width: 150,
            editable: false,
            valueFormatter: params => params?.value?.map(c => CountryCodeMap[c] || c) || '-'
        },              
        {
            field: 'action',
            headerName: 'Action',
            sortable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    selectRow(params.row);
                };

                return (
                    <Button variant="contained" color="primary" onClick={onClick}>
                        Assign
                    </Button>
                );
            },
        },
    ];

    return (
        <>
            <Box sx={{ flex: 1 }}>
                <DataGridPro
                    rows={gridList}
                    columns={columns}
                    pagination={true}
                    pageSize={10}
                    components={{ Toolbar: BundleGridToolbar }} 
                    componentsProps={{ toolbar : { updateFilters } }}
                    initialState={{
                        sorting: {
                            sortModel: [{ field: 'location', sort: 'desc' }],
                        },
                    }}
                    sx={{
                        '.MuiDataGrid-columnHeaders': {
                            fontWeight: 'bold',
                            fontSize: 14,
                            color: 'rgb(0,0,0)',
                            backgroundColor: 'rgb(244,246,248)',
                        },
                        '.MuiTablePagination-selectLabel': {
                            marginBottom: '0px',
                        },
                        '.MuiTablePagination-displayedRows': {
                            marginBottom: '0px',
                        },
                        '.MuiPaper-root.div.span': {
                            color: 'blue',
                        },
                    }}
                />
            </Box>
        </>
    );
}


function BundleGridToolbar({ updateFilters}) {
    
    const [selectedTags, setSelectedTags] = React.useState('');

    function tagsFilterChanged(val) {
        updateFilters({ tags: val });
        setSelectedTags(val);
    }
    
    return (
        <Box sx={{ display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center' }}>
            <GridToolbarContainer style={{ paddingTop: '10px' }}>
                <GridToolbarQuickFilter placeholder='Search Name...'/>
            </GridToolbarContainer>
            <Box sx={{ display : 'flex', width : '300px', alignItems : 'center'}}>
                <Typography sx={{ mr : 10}} >Category</Typography>
            
                <Select
                size="small"
                fullWidth
                labelId="mx-filter-tag-label"
                id="mx-filter-tag"
                value={selectedTags}
                onChange={(e) => tagsFilterChanged(e.target.value)}
                >
                    {BundleTypeList.map((c) => (
                                            <MenuItem value={c.code}>{c.label}</MenuItem>
                                        ))}
                </Select>

            </Box>
        </Box>
    );
}